__turbopack_context__.v({
  "icon": "UserMenu-module__MFoIga__icon",
  "support": "UserMenu-module__MFoIga__support",
  "user": "UserMenu-module__MFoIga__user",
});
